import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'components/form/InputFields/MobianPhoneInput/ReactPhoneInput';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import { parsePhoneNumberFromString, isValidNumber } from 'libphonenumber-js';

const StyleWrapper = styled.div`
    padding-top: 14px;
    height: 58px;
    width: ${ (props) => {
        return props.width ? props.width : 'auto';
    } };

    .react-tel-input {
        width: 100% !important;

        input[type="tel"] {
            font: inherit;
            border: 0;
            border-radius: 0;
            box-shadow: initial;
            border-bottom: ${ (props) => {
                if (props.error) {
                    return '2px solid rgb(244, 67, 54)';
                }

                if (props.warning) {
                    return '2px solid #FF8D05';
                }

                return '1px solid rgb(224, 224, 224)';
            } };
            transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;

            &:focus{
                outline: 0;
                border-bottom: 2px solid ${ (props) => {
                    if (props.error) {
                        return 'rgb(244, 67, 54)';
                    }

                    if (props.warning) {
                        return '#FF8D05';
                    }

                    return 'rgb(51, 139, 134)';
                } };
            }
        }

        .flag-dropdown {
            border: 0;
            background: transparent;
        }
    }
`;

const Label = styled.label`
    font-size: 12px;
    color: ${ (props) => {
        if (props.error) {
            return 'rgb(244, 67, 54)';
        }

        if (props.warning) {
            return '#FF8D05';
        }

        return 'rgb(102, 102, 102)';
    } };
    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`;

const ErrorText = styled.div`
    margin-top: 10px;
    font-size: 12px;
    line-height: 12px;
    height: 12px;
    color: rgb(244, 67, 54);
    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`;

const WarningText = styled.div`
    margin-top: 10px;
    font-size: 12px;
    line-height: 12px;
    height: 12px;
    color: #FF8D05;
    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`;

class PhoneField extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);

        let defaultCountry = props.defaultCountry;
        let { value } = props.input;

        if (value.indexOf('00') === 0) {
            value = value.replace('00', '+');
        }

        const phoneNumber = parsePhoneNumberFromString(value, defaultCountry);

        if (phoneNumber) {
            defaultCountry = phoneNumber.country;
        }

        this.state = {
            defaultCountry: defaultCountry.toLowerCase(),
        };
    }

    handleChange(value) {
        const { input: { onChange } } = this.props;

        if (value === '+') {
            return onChange('');
        }

        onChange(value);
    }

    render() {
        const {
            input: {
                value: oldValue,
            },
            label,
            meta: {
                error,
                dirty,
                touched,
            },
            style: {
                width,
            },
        } = this.props;

        let value = oldValue;

        // If a phonenumber is saved as e.g. 0031 231234567 then we'll swap the 00 for a + to work properly with the phone field
        if (oldValue.indexOf('00') === 0) {
            value = oldValue.replace('00', '+');
        }

        const hasError = (dirty || touched) && !!error;
        const hasWarning = dirty && !isValidNumber(value);

        return (
            <StyleWrapper width={ width } error={ hasError } warning={ hasWarning }>
                <Label error={ hasError } warning={ hasWarning }>
                    { label }
                </Label>

                <PhoneInput
                    defaultCountry={ this.state.defaultCountry }
                    onChange={ this.handleChange }
                    value={ value }
                    error={ hasError }
                    warning={ hasWarning }
                />

                { hasError &&
                    <ErrorText>
                        { error }
                    </ErrorText>
                }

                { !hasError && hasWarning &&
                    <WarningText>
                        { this.props.translate('forms.invalid.phone') }
                    </WarningText>
                }
            </StyleWrapper>
        );
    }
}

PhoneField.defaultProps = {
    required: false,
    defaultCountry: 'nl',
    style: {
        width: '100%',
    },
};

PhoneField.propTypes = {
    defaultCountry: PropTypes.string,
    input: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string,
    }),
    label: PropTypes.string,
    meta: PropTypes.shape({
        dirty: PropTypes.bool,
        error: PropTypes.string,
        touched: PropTypes.bool,
    }),
    style: PropTypes.shape({
        width: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    }),
    translate: PropTypes.func,
};

export default translate(PhoneField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/MobianPhoneInput/PhoneInput.js